import {
  AbilityClaim,
  DeleteEncounterClaimDraftArgs,
  GetClaimArgs,
  LinkClaimArgs,
  SaveEncounterClaimDraftArgs,
  SubmitEncounterClaimArgs,
  SubmitPregnancyClaimArgs,
  UpdateCallback,
} from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from './functions'

export const linkClaim = httpsCallable<LinkClaimArgs>(functions, 'linkClaim')
export const submitPregnancyClaim = httpsCallable<SubmitPregnancyClaimArgs>(
  functions,
  'submitPregnancyClaim',
)
export const submitEncounterClaim = httpsCallable<SubmitEncounterClaimArgs>(
  functions,
  'submitEncounterClaim',
)
export const saveEncounterClaimDraft = httpsCallable<SaveEncounterClaimDraftArgs, UpdateCallback>(
  functions,
  'saveEncounterClaimDraft',
)
export const deleteEncounterClaimDraft = httpsCallable<
  DeleteEncounterClaimDraftArgs,
  UpdateCallback
>(functions, 'deleteEncounterClaimDraft')
export const testClaimSubmission = httpsCallable<SubmitPregnancyClaimArgs>(
  functions,
  'testClaimSubmission',
)
export const getClaim = httpsCallable<GetClaimArgs, AbilityClaim>(functions, 'getClaim')
